import Grid from '@material-ui/core/Grid';

export default function File({ originalFileName }) {
	return (
		<Grid className="flex flex-row gap-x-3 items-center">
			<Grid>ชื่อเอกสาร: {originalFileName ?? 'ยังไม่ได้เลือกไฟล์'}</Grid>
		</Grid>
	)
}
